import { createFileRoute } from "@tanstack/react-router";

import { OrganisationList } from "@/components/OrganisationList";

export const Route = createFileRoute("/_authenticated/organisations/")({
  component: OrganisationsPage,
});

function OrganisationsPage() {
  return <OrganisationList />;
}
